import { css } from 'styled-components'
import { media } from '../../utilities/styled'

const mobileBreakpoint = 'tablet'

const defaultStyles = css`
  color: ${({ active, color, theme }) =>
    active ? theme.colors.orange : theme.colors[color] || theme.colors.black};
`

const h1Style = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 36px;
  line-height: 40px;

  ${media[mobileBreakpoint]`
    font-size: 28px;
    line-height: 32px;
  `};
`

const h1XlStyle = css`
  ${defaultStyles};
  ${h1Style} font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 42px;
  line-height: 48px;

  ${media[mobileBreakpoint]`
    font-size: 30px;
    line-height: 34px;
  `};
`

const h1XxlStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 52px;
  line-height: 58px;

  ${media[mobileBreakpoint]`
    font-size: 36px;
    line-height: 40px;
  `};
`

const h2Style = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 30px;
  line-height: 34px;

  ${media[mobileBreakpoint]`
    font-size: 28px;
    line-height: 32px;
  `};
`

const h3Style = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 24px;
  line-height: 28px;

  ${media[mobileBreakpoint]`
    font-size: 24px;
    line-height: 28px;
  `};
`

const h4Style = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 20px;
  line-height: 22px;

  ${media[mobileBreakpoint]`
    font-size: 18px;
    line-height: 22px;
  `};
`

const h5Style = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 18px;
  line-height: 26px;
`

const h6Style = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 20px;
  line-height: 28px;

  ${media[mobileBreakpoint]`
    font-size: 16px;
    line-height: 24px;
  `};
`

const h6NoBreakStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 20px;
  line-height: 28px;
`

const streamerStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-style: italic;
  font-size: 36px;
  line-height: 48px;

  ${media[mobileBreakpoint]`
    font-size: 24px;
    line-height: 32px;
  `};
`

const introStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 24px;
  line-height: 32px;

  ${media[mobileBreakpoint]`
    font-size: 20px;
    line-height: 28px;
  `};
`

const headerStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;

  ${media[mobileBreakpoint]`
    font-size: 16px;
    line-height: 24px;
  `};
`

const listStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 24px;
  line-height: 32px;

  ${media[mobileBreakpoint]`
    font-size: 18px;
    line-height: 24px;
  `};
`

const listSmStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 20px;
  line-height: 28px;

  ${media[mobileBreakpoint]`
    font-size: 16px;
    line-height: 24px;
  `};
`

const bodyStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 20px;
  line-height: 28px;

  strong {
    font-weight: bold;
  }

  ${media[mobileBreakpoint]`
    font-size: 18px;
    line-height: 26px;
  `};
`

const bodySmStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 16px;
  line-height: 24px;
`

const bodySStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 18px;
  line-height: 24px;
`

const bodyXsStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 14px;
  line-height: 24px;
  display: inline-block;
`

const bodyXxsStyle = css`
  ${defaultStyles};
  font-family: elsevier-sans;
  font-feature-settings: 'pnum' on,'lnum' on;
  font-size: 12px;
  line-height: 10px;
  display: inline-block;
`

const linkStyle = css`
  color: ${({ theme }) => theme.colors.petrolBlue};
  border-bottom: 2px solid transparent;

  &:hover,
  &:active,
  &:focus {
      border-bottom: 2px solid ${({ theme }) => theme.colors.petrolBlue};
    }
  }
`


const styles = {
  h1: h1Style,
  h1Xl: h1XlStyle,
  h1Xxl: h1XxlStyle,
  h2: h2Style,
  h3: h3Style,
  h4: h4Style,
  h5: h5Style,
  h6: h6Style,
  h6Nb: h6NoBreakStyle,
  streamer: streamerStyle,
  intro: introStyle,
  header: headerStyle,
  list: listStyle,
  listSm: listSmStyle,
  body: bodyStyle,
  bodyS: bodySStyle,
  bodySm: bodySmStyle,
  bodyXs: bodyXsStyle,
  bodyXxs: bodyXxsStyle,
  link: linkStyle,
}

const tagMap = {
  h1: 'h1',
  h1Xl: 'h1',
  h1Xxl: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  h6Nb: 'h6',
  streamer: 'p',
  intro: 'p',
  header: 'h5',
  list: 'li',
  listSm: 'li',
  body: 'p',
  bodyS: 'p',
  bodySm: 'p',
  bodyXs: 'span',
  bodyXxs: 'span',
  link: 'a',
}

const exportedObject = {
  styles,
  tagMap,
};

export default exportedObject;